import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { api } from "../../../api/apiService";
import { Link } from "react-router-dom";
import DeleteModal from "../../../components/Modal/DeleteModal";
import BranchesModal from "../../../components/Modal/BranchesModal";

const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [showModal, setShowModal] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentBranch, setCurrentBranch] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      const response = await api.get("/branches");
      setBranches(response.data.data);
    } catch (error) {
      console.error("Error fetching branches: ", error);
      toast.error("Failed to fetch branches");
    }
  };

  const handleAddBranch = () => {
    setCurrentBranch({
      name: "",
      address: "",
      phone: "",
    });
    setIsEditing(false);
    setShowModal("data");
  };

  const handleEditBranch = (branch) => {
    setCurrentBranch(branch);
    setIsEditing(true);
    setShowModal("data");
  };

  const handleDeleteBranch = async () => {
    if (!currentBranch) return;
    try {
      setIsLoading(true);
      await api.delete(`/branches/${currentBranch?.branch_id}`);
      setBranches((prev) =>
        prev.filter((dept) => dept.branch_id !== currentBranch?.branch_id)
      );
      toast.success("branch deleted successfully");
    } catch (error) {
      console.error("Error deleting branch: ", error);
      toast.error("Error deleting branch");
    } finally {
      setIsLoading(false);
      setShowModal(null);
    }
  };

  const saveBranch = async (data) => {
    setIsLoading(true);
    try {
      if (isEditing && currentBranch) {
        const branchId = currentBranch.branch_id;

        if (!branchId) {
          throw new Error("Branch ID is undefined");
        }

        await api.put(`/branches/${branchId}`, data);
        toast.success("Branch updated successfully");
      } else {
        await api.post("/branches", data);
        toast.success("Branch added successfully");
      }
      fetchBranches();
      setShowModal(null);
    } catch (error) {
      console.error("Error saving branch: ", error);
      toast.error(error.data.error || "Error saving branch");
    } finally {
      setIsLoading(false);
      setCurrentBranch(null);
    }
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Branches</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/home">Home</Link>
            </li>
            <li className="breadcrumb-item active">Branches</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Branches Management</h5>
                <div>
                  <button
                    className="btn btn-primary mb-3"
                    onClick={handleAddBranch}
                  >
                    Add Branch
                  </button>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {branches?.map((branch, index) => (
                        <tr key={branch.branch_id || index}>
                          <td>{branch.name}</td>
                          <td>{branch.phone}</td>
                          <td>{branch.address}</td>
                          <td>
                            <button
                              className="btn btn-warning btn-sm me-2"
                              onClick={() => handleEditBranch(branch)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                setCurrentBranch(branch);
                                setShowModal("delete");
                              }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {showModal === "data" && (
                    <BranchesModal
                      show={true}
                      onClose={() => setShowModal(null)}
                      onSubmit={saveBranch}
                      isLoading={isLoading}
                      isEditing={isEditing}
                      defaultValues={{
                        name: currentBranch?.name || "",
                        phone: currentBranch?.phone || "",
                        address: currentBranch?.address || "",
                      }}
                    />
                  )}

                  {showModal === "delete" && (
                    <DeleteModal
                      show={true}
                      onClose={() => setShowModal(null)}
                      onDelete={handleDeleteBranch}
                      isLoading={isLoading}
                      body={
                        <>
                          Are you sure you want to delete the branch{" "}
                          <strong className="text-capitalize">
                            {currentBranch?.name}
                          </strong>
                          ?
                        </>
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Branches;
